/**
 * Wasrapport als tijdlijn. Brontekst blijft `[dd-MM-yyyy HH:mm Context] regel`
 * (nieuwste eerst); we parsen dat alleen voor weergave. Ongestructureerde
 * historie valt terug op één blok, zodat we nooit stilletjes regels kwijtraken.
 */

export interface WasrapportRegel {
  stempel: string;
  context: string;
  body: string;
}

const KOP = /^\[(\d{2}-\d{2}-\d{4} \d{2}:\d{2}) ([^\]]+)\] /gm;

export function parseWasrapport(raw: string): WasrapportRegel[] {
  const text = raw.replace(/^\uFEFF/, '').trim();
  if (!text) return [];
  const matches = [...text.matchAll(KOP)];
  if (matches.length === 0) return [{ stempel: '', context: '', body: text }];
  return matches.map((m, i) => {
    const start = (m.index ?? 0) + m[0].length;
    const end = i + 1 < matches.length ? (matches[i + 1].index ?? text.length) : text.length;
    return {
      stempel: m[1] ?? '',
      context: m[2] ?? '',
      body: text.slice(start, end).trim(),
    };
  });
}

interface Props {
  raw: string;
}

export function WasrapportTimeline({ raw }: Props) {
  const regels = parseWasrapport(raw);
  if (regels.length === 0) {
    return <p className="text-sm text-slate-400">Nog geen wasrapport.</p>;
  }

  return (
    <ol className="space-y-3">
      {regels.map((r, i) => (
        <li key={`${r.stempel}-${i}`} className="relative pl-4 border-l-2 border-slate-200">
          <span className="absolute -left-[5px] top-1.5 w-2 h-2 rounded-full bg-slate-300" />
          <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
            {r.context && (
              <span className="text-[11px] font-medium uppercase tracking-wide text-slate-500">
                {r.context}
              </span>
            )}
            {r.stempel && <span className="text-[11px] text-slate-400 tabular-nums">{r.stempel}</span>}
          </div>
          <p className="mt-0.5 text-sm text-slate-800 whitespace-pre-wrap">{r.body}</p>
        </li>
      ))}
    </ol>
  );
}
